import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TSFuntionService } from '../../services/ts-funtion.service';

@Component({
  selector: 'app-session-timeout',
  templateUrl: './session-timeout.component.html',
  styleUrls: ['./session-timeout.component.css']
})
export class SessionTimeoutComponent implements OnInit {

  constructor(private http: HttpClient, private System: TSFuntionService) {
    //setInterval(() => this.CheckTimeOut(), 1000);
  }

  Result: string = "";
  ResultMail: string = "";
  ngOnInit() {
    //this.Authen.sessionTimeoutIn = 20;
    //this.Authen.CreateTimeInterval();
  }

  CheckTimeOut() {
    let This = this;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    this.http.post("api/SessionTimeOut/GetSessionExpire", {}, { headers, responseType: 'text' }).subscribe(res => {
      This.Result = This.Result + " " + this.System.TimeoutCounting + " : " + res + "";
    });
  }

  MailTo = "";
  MailFrom = "";
  SMTP = "";
  USER = "";
  PASSWORD = "";
  PORT = "";
  TestMail() {
    let This = this;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    let Data = {
      MailTo : this.MailTo,
      MailFrom: this.MailFrom,
      SMTP: this.SMTP,
      USER: this.USER,
      PASSWORD: this.PASSWORD,
      PORT: this.PORT
    }

    this.http.post("api/SessionTimeOut/TestMail", JSON.stringify(Data), { headers, responseType: 'text' }).subscribe(res => {
      This.Result = res;
    });
  }

  Connect() {
    this.System.ConnectSession();
  }

  ArrController:any = [];
  GetController() {
    let This = this;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    this.http.get<any>("api/SessionTimeOut/GetController").subscribe(res => {
      this.ArrController = res;
    });
  }

}
